export default {"src":"/_next/static/media/flash-logo-footer.b304801b.svg","height":283,"width":800,"blurWidth":0,"blurHeight":0};